export class Catch {

    public ICES: string;
    public CatchYear: number;
    public FactoryId: string;
    public FactoryName: string;
    public FactoryICES: string;
    public Catches: number;
    public TotalWeight: number;
}